import React from "react";
import Styles from "../ConnectionAcceptModal/ConnectionAcceptModal.module.css";
import { CircularProgress, Modal } from "@mui/material";
import { ReactComponent as ErrorIcon } from "../../../../assets/images/hold.svg";

const HoldModal = ({ open, handleClose, onConfirm, loading = false }) => {
  return (
    <Modal
      open={open}
      onClose={!loading ? handleClose : undefined} 
    >
      <div className={Styles.createEditModalCont}>
        <div className={`headingText ${Styles.withdrawText}`}>Hold</div>

        <div className={`${Styles.headerSection} ${Styles.withdrawSection}`}>
          <ErrorIcon style={{ width: "50px", height: "50px" }} />

          <span>
            Do you want to{" "}
            <span
              style={{
                fontWeight: "500",
                color: "var(--hold-text-shade)",
              }}
            >
              hold
            </span>{" "}
            this
          </span>
          <span>listing?</span>
        </div>

        <div className={Styles.buttonSection}>
          {/* NO */}
          <div
            className={`${Styles.clickBox} ${
              loading ? Styles.disabledBtn : ""
            }`}
            onClick={!loading ? handleClose : undefined}
          >
            {/* {loading ? <CircularProgress size={18} /> : <span>No</span>} */}
            No
          </div>

          {/* YES */}
          <div
            className={`${Styles.clickBox} ${
              loading ? Styles.disabledBtn : ""
            }`}
            onClick={!loading ? onConfirm : undefined}
          >
            {loading ? (
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                {/* <CircularProgress size={18} /> */}
                <span>Processing...</span>
              </div>
            ) : (
              <span>Yes</span>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default HoldModal;
